import PropTypes from "prop-types";
import { useState } from "react";
import { Snackbar, Alert, TextField, Box, InputAdornment, Icon } from "@mui/material";

function DOBField({ displayName, fieldRef, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errMsg, setErrMsg] = useState("Invalid date of birth provided.");

  function calculateAge(birthday) {
    // birthday is a date
    const ageDifMs = Date.now() - birthday;
    const ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  return (
    <Box>
      <TextField
        name={fieldRef}
        margin="dense"
        label={displayName}
        type="date"
        fullWidth
        variant="outlined"
        InputProps={{
          startAdornment: <InputAdornment position="start"><Icon>calendar_month</Icon></InputAdornment>,
        }}
        onBlur={(e) => {
          const dob = e.target.value;
          const dobDate = new Date(dob);
          const age = calculateAge(dobDate);
          let ageMin = 0;
          if (typeof options.min_age === "undefined") {
            ageMin = 18;
          } else {
            ageMin = options.min_age;
          }

          if (age < ageMin) {
            e.target.value = null;
            setErrMsg(`A minimum age of ${ageMin} is required`);
            showFieldError(true);
            return;
          }

          if (typeof options.max_age !== "undefined") {
            if (age > options.max_age) {
              e.target.value = null;
              setErrMsg(`A maximum age of ${options.max_age} is required`);
              showFieldError(true);
            }
          }
        }}
        options={options}
      />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
}

// Typechecking props of the Transaction
DOBField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

DOBField.defaultProps = {
  options: null,
};

export default DOBField;
